import React, { useState, useEffect } from "react";

const UserPopup = ({ selectedUser, onClose, onUpdate }) => {
  const [user, setUser] = useState(selectedUser);
  useEffect(() => {
    setUser(selectedUser);
  }, [selectedUser]);

  const handleUpdate = () => {
    onUpdate(user);
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded shadow-lg w-full md:w-3/4 lg:w-1/2 xl:w-1/3 dark:bg-gray-800 dark:text-white">
        <h2 className="text-xl font-bold mb-4">
          Cập nhật thông tin người dùng
        </h2>
        <div className="space-y-4">
          <div className="flex space-x-4">
            <div className="flex-1">
              <label className="block mb-2 text-left">Họ:</label>
              <input
                type="text"
                value={user.lastName}
                onChange={(e) =>
                  setUser({
                    ...user,
                    lastName: e.target.value,
                  })
                }
                className="border rounded p-2 w-full dark:bg-gray-700 dark:text-white"
              />
            </div>
            <div className="flex-1">
              <label className="block mb-2 text-left">Tên:</label>
              <input
                type="text"
                value={user.firstName}
                onChange={(e) =>
                  setUser({
                    ...user,
                    firstName: e.target.value,
                  })
                }
                className="border rounded p-2 w-full dark:bg-gray-700 dark:text-white"
              />
            </div>
          </div>
          <div className="flex space-x-4">
            <div className="flex-1">
              <label className="block mb-2 text-left">Số điện thoại:</label>
              <input
                type="text"
                value={user.phoneNumber}
                readOnly
                className="border rounded p-2 w-full dark:bg-gray-700 dark:text-white"
              />
            </div>
            <div className="flex-1">
              <label className="block mb-2 text-left">Email:</label>
              <input
                type="email"
                value={user.email}
                onChange={(e) =>
                  setUser({
                    ...user,
                    email: e.target.value,
                  })
                }
                className="border rounded p-2 w-full dark:bg-gray-700 dark:text-white"
              />
            </div>
          </div>
          <div className="flex space-x-4">
            <div className="flex-1">
              <label className="block mb-2 text-left">Địa chỉ:</label>
              <input
                type="text"
                value={user.address}
                onChange={(e) =>
                  setUser({
                    ...user,
                    address: e.target.value,
                  })
                }
                className="border rounded p-2 w-full dark:bg-gray-700 dark:text-white"
              />
            </div>
            <div className="flex-1">
              <label className="block mb-2 text-left">Người liên hệ:</label>
              <input
                type="text"
                value={user.contactPerson}
                onChange={(e) =>
                  setUser({
                    ...user,
                    contactPerson: e.target.value,
                  })
                }
                className="border rounded p-2 w-full dark:bg-gray-700 dark:text-white"
              />
            </div>
          </div>
          <div className="flex space-x-4">
            <div className="flex-1">
              <label className="block mb-2 text-left">Doanh thu:</label>
              <input
                type="number"
                value={user?.totalSales}
                onChange={(e) =>
                  setUser({
                    ...user,
                    totalSales: e.target.value,
                  })
                }
                className="border rounded p-2 w-full dark:bg-gray-700 dark:text-white"
              />
            </div>
            <div className="flex-1">
              <label className="block mb-2 text-left">Ngày sinh:</label>
              <input
                type="date"
                value={user?.birthDay}
                onChange={(e) =>
                  setUser({
                    ...user,
                    birthDay: e.target.value,
                  })
                }
                className="border rounded p-2 w-full dark:bg-gray-700 dark:text-white"
              />
            </div>
          </div>
        </div>

        <div className="text-left">
          <div>
            <b>Số ngày hoạt động: </b>
            {user.numTotalDateActivity} ngày
          </div>
          <div>
            <div className="space-y-2">
              <h3 className="font-semibold">Thống kê bài đăng:</h3>
              <div className="flex w-full">
                <p className="flex-1">
                  Số bài đăng: {user.detailNumPosts.totalPosts}
                </p>
                <p className="flex-1">
                  Số bài chờ duyệt: {user.detailNumPosts.totalWaits}
                </p>
              </div>
              <div className="flex w-full">
                <p className="flex-1">
                  Số bài đã duyệt: {user.detailNumPosts.totalAccepts}
                </p>
                <p className="flex-1">
                  Số bài đã từ chối: {user.detailNumPosts.totalRejects}
                </p>
              </div>
              <p>Số bài đã hủy: {user.detailNumPosts.totalCancels}</p>
            </div>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            onClick={handleUpdate}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Cập nhật
          </button>
          <button
            onClick={onClose}
            className="ml-2 bg-gray-300 text-black px-4 py-2 rounded dark:bg-gray-600 dark:text-white"
          >
            Đóng
          </button>
        </div>
      </div>
     
    </div>
  );
};

export default UserPopup;
